exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transparent-header > th {\n  vertical-align: bottom;\n  border: none; }\n\n.bg-header {\n  background-color: #c3c7c9; }\n\n.noborder {\n  border: none; }\n\n.graphMarketPerformance {\n  width: 700px;\n  height: 400px; }\n\n.configGraphMarketPerformance {\n  width: 100%;\n  height: 400px;\n  background-color: #FFFFFF; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/global-index-member/global-index-member.component.scss
// module id = ../../../../../src/app/market-level/global-index-member/global-index-member.component.scss
// module chunks = main